import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMessageSquare, FiActivity, FiArrowRight } = FiIcons;

const Home = () => {
  // Using raw=1 for direct embedding
  const logoUrl = "https://www.dropbox.com/scl/fi/m1e6agmnwiz92uid4bx3y/Gyso-Call-Logo.png?rlkey=encbf5fh2ngjiiaqwtploq2ec&st=4fwrw1vl&raw=1";

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center">
        <div className="flex justify-center mb-6">
          <img className="h-24 w-auto" src={logoUrl} alt="Gyso Call" />
        </div>
        <p className="mt-5 max-w-xl mx-auto text-xl text-gray-500">
          Manage your SMS communications, phone calls, and numbers in one centralized dashboard.
        </p>
        <div className="mt-8 flex justify-center">
          <Link
            to="/twilio"
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 md:text-lg transition-colors duration-150"
          >
            Go to Dashboard <SafeIcon icon={FiArrowRight} className="ml-2" />
          </Link>
        </div>
      </div>

      <div className="mt-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          <div className="pt-6">
            <div className="flow-root bg-white rounded-lg px-6 pb-8 shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-200">
              <div className="-mt-6">
                <div>
                  <span className="inline-flex items-center justify-center p-3 bg-blue-500 rounded-md shadow-lg">
                    <SafeIcon icon={FiMessageSquare} className="h-6 w-6 text-white" />
                  </span>
                </div>
                <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">SMS Console</h3>
                <p className="mt-5 text-base text-gray-500">
                  Send messages, view history, and manage templates with ease.
                </p>
              </div>
            </div>
          </div>

          <div className="pt-6">
            <div className="flow-root bg-white rounded-lg px-6 pb-8 shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-200">
              <div className="-mt-6">
                <div>
                  <span className="inline-flex items-center justify-center p-3 bg-green-500 rounded-md shadow-lg">
                    <SafeIcon icon={FiPhone} className="h-6 w-6 text-white" />
                  </span>
                </div>
                <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">Call Management</h3>
                <p className="mt-5 text-base text-gray-500">
                  Initiate outbound calls and track call logs and durations.
                </p>
              </div>
            </div>
          </div>

          <div className="pt-6">
            <div className="flow-root bg-white rounded-lg px-6 pb-8 shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-200">
              <div className="-mt-6">
                <div>
                  <span className="inline-flex items-center justify-center p-3 bg-indigo-500 rounded-md shadow-lg">
                    <SafeIcon icon={FiActivity} className="h-6 w-6 text-white" />
                  </span>
                </div>
                <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">Real-time Logs</h3>
                <p className="mt-5 text-base text-gray-500">
                  Monitor inbound events and webhooks in real-time.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;